import React from "react"
import autobind from "class-autobind"
import { Card, FlatButton, CardHeader, CardText, CardActions, FontIcon, TextField, SelectField, MenuItem, CircularProgress } from "material-ui"
import strings from "../../localization/strings"
import { amber50 } from "material-ui/styles/colors"
import { IDate, INoteDocument, INoteObjectData, INoteType, IUserDocument } from "../../models"
import * as utils from "../../helpers/utils"
import AccountStore from "../../stores/AccountStore"
import * as api from "../../api"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
import AppStateStore from "../../stores/AppStateStore"
import authenticationStore from "../../stores/AuthenticationStore"

interface IProps {
    objectData: INoteObjectData
    objectName: string,
    // it should be LocalTime of UTC format
    noteReferenceDate?: IDate
    getNotes(): void
    closeDrawer(): void
    dataType: string
}

interface IState {
    adding: boolean
    title: string
    errorTitle: string
    note: string
    errorNote: string
    selectedGroup: string
    enableScripts: boolean
    frontEndFormScript: string
    frontEndScript: string
    frontEndPostValidationScript: string
    noteTypes: INoteType[]
    selectedNoteType: INoteType
    noteGroup: string
    subscriberList: string
    subscriberListError: string
    accountUsers: IUserDocument[]
    loadingDependancies: boolean
}

export default class AddNewNote extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            adding: false,
            title: "",
            errorTitle: "",
            note: "",
            errorNote: "",
            noteTypes: [],
            accountUsers: [],
            selectedGroup: "-1",
            frontEndScript: null,
            frontEndFormScript: null,
            frontEndPostValidationScript: null,
            noteGroup: null,
            selectedNoteType: null,
            subscriberList: null,
            subscriberListError: null,
            loadingDependancies: false,
            enableScripts: false,
        }
        autobind(this)
    }

    getSupportingData() {
        this.setState({ loadingDependancies: true }, () =>
            api.getNoteTypes(AccountStore.getCurrentAccount().Id).then(res => {
                let noteTypes = res.data as INoteType[]
                noteTypes = noteTypes.filter(i => i.Active)
                noteTypes.length > 0 ?
                    this.setState({
                        noteTypes: noteTypes.filter(item => {
                            if (item.ObjectAudit && item.ObjectAudit.Security && item.ObjectAudit.Security.EnableSecurity) {
                                if (item.ObjectAudit.Security.CreateAccessRoleIdList.includes(authenticationStore.LoggedInUser.UserRoleId)) {
                                    return true
                                } else {
                                    return false
                                }
                            } else {
                                return true
                            }
                        }),
                    }, () =>
                        api.getAccountUsers(AccountStore.getCurrentAccount().Id).then(res =>
                            this.setState({
                                loadingDependancies: false,
                                accountUsers: res.data.Documents,
                            })
                        )
                    ) :
                    this.setState({ loadingDependancies: false })
            })
        )
    }

    saveNoteData() {
        let notePayload = {
            Id: utils.guid(),
            AccountId: AccountStore.getCurrentAccount().Id,
            ObjectId: this.props.objectData.ObjectId ? this.props.objectData.ObjectId : null,
            ObjectName: this.props.objectName,
            Title: this.state.title.trim(),
            Note: this.state.note,
            ReferenceDate: this.props.noteReferenceDate ? moment(timeHelper.keepConvertUTCToLocal(this.props.noteReferenceDate)).utc(true).format() : null,
            TimecardRef: this.props.objectData.TimecardRef ? this.props.objectData.TimecardRef : null,
            SubscriberEmailList: this.state.subscriberList,
        } as INoteDocument

        if (this.state.selectedNoteType) {
            notePayload.NoteType = {
                Id: this.state.selectedNoteType.Id,
                Name: this.state.selectedNoteType.Name,
                Group: this.state.selectedNoteType.Group,
                ObjectAttribute: this.state.selectedNoteType.ObjectAttribute,
                ObjectAudit: this.state.selectedNoteType.ObjectAudit,
            } as INoteType
        }

        if (this.checkValidate()) {
            if (this.state.enableScripts) {
                let noteTypeClassName = this.getScopeId(this.state.selectedNoteType)
                let formBuilderReturnData = eval(noteTypeClassName).submitForm(this.getScopeId(this.state.selectedNoteType), AccountStore.getCurrentAccount(), {...this.props.objectData,noteReferenceDate: this.props.noteReferenceDate ? moment(timeHelper.keepConvertUTCToLocal(this.props.noteReferenceDate)).utc(true).format() : null}, this.state.accountUsers)

                notePayload.Title = formBuilderReturnData.noteTitle
                notePayload.Note = formBuilderReturnData.noteBody
                notePayload.SubscriberEmailList = formBuilderReturnData.noteSubscriberEmailList
                notePayload.FormData = JSON.stringify(formBuilderReturnData.formData)

                //walledGardenUtil
            }

            this.setState({ adding: true }, () =>
                api.addNote(notePayload).then(() => {
                    this.props.closeDrawer()
                    this.props.getNotes()
                })
            )
        }
    }

    checkValidate() {
        let isValidate = true

        if (this.state.enableScripts) {
            let noteTypeClassName = this.getScopeId(this.state.selectedNoteType)
            let formBuilderReturnData = eval(noteTypeClassName).submitForm(this.getScopeId(this.state.selectedNoteType), AccountStore.getCurrentAccount(), this.props.objectData, this.state.accountUsers)

            if (!formBuilderReturnData.success) {
                this.setState({ errorTitle: formBuilderReturnData.errorText })
                return false
            } else {
                try {
                    this.state.frontEndPostValidationScript &&
                        eval(noteTypeClassName).postValidation({ Api: api, AppStateStore: AppStateStore }, AccountStore.getCurrentAccount(), this.props.objectData, this.state.accountUsers)
                } catch (e) {
                    this.setState({ errorTitle: e.message })
                    return false
                }

                this.setState({ errorTitle: "" })
                return true
            }
        }

        if (this.state.subscriberList && !utils.validateEmailListString(this.state.subscriberList)) {
            this.setState({ subscriberListError: strings.NoteSubscriberListError })
            isValidate = false
        } else {
            this.setState({ subscriberListError: "" })
        }

        if (!this.state.title.trim()) {
            this.setState({ errorTitle: strings.This_field_is_required })
            isValidate = false
        } else {
            this.setState({ errorTitle: "" })
        }

        if (!this.state.note.trim()) {
            this.setState({ errorNote: strings.This_field_is_required })
            isValidate = false
        } else {
            this.setState({ errorNote: "" })
        }

        return isValidate
    }

    componentDidMount() {
        this.getSupportingData()
    }

    groupBy(collection, property) {
        var i = 0, val, index, values = [], result = [];

        for (; i < collection.length; i++) {
            val = collection[i][property];
            index = values.indexOf(val);

            if (index <= -1) {
                values.push(val);
                result.push(collection[i].Group);
            }
        }

        return result
    }

    getNoteTypeByGroup(collection, groupName) {
        var i = 0, result = [];

        for (; i < collection.length; i++) {
            if (collection[i].Group === groupName) {
                result.push(collection[i]);
            }
        }

        return result
    }

    getScopeId(noteType: INoteType) {
        return "NoteType_" + noteType.Id.replace(/-/g, '_')
    }

    renderFrontEndScriptToDom(noteType: INoteType) {
        const noteTypeClassName = this.getScopeId(noteType)
        const scriptText = "class " + noteTypeClassName + "{\n\r" + this.state.frontEndScript + this.state.frontEndPostValidationScript + "\n\r}"

        var head = document.getElementsByTagName('head')[0]
        var tag = document.createElement('script')
        tag.type = 'text/javascript'
        tag.id = noteTypeClassName
        tag.textContent = scriptText

        var script = document.getElementById(noteTypeClassName)
        if (script == null) {
            head.appendChild(tag)
        }
    }

    render() {
        const noteTypes = this.getNoteTypeByGroup(this.state.noteTypes, this.state.selectedGroup).filter(noteType => noteType.DataType === this.props.dataType || this.props.dataType == "all" || !this.props.dataType)
        const filteredNoteTypes = this.state.noteTypes.filter(noteType => noteType.DataType === this.props.dataType || this.props.dataType == "all" || !this.props.dataType)
        const groups = this.groupBy(filteredNoteTypes, "Group")

        return (
            <div>
                <Card style={{ boxShadow: "none" }}>
                    <CardHeader
                        style={{ backgroundColor: AppStateStore.getFrontEndSettings().UISettings.AccentColor, height: 90, textAlign: "center" }}
                        title={
                            <h2>{strings.Add_New_Note}</h2>
                        }
                        children={
                            <FontIcon
                                data-intercom-target={"Notes-Add-Btn-Close-Add-New-Note-Drawer"}
                                onTouchTap={() => this.props.closeDrawer()}
                                className="fa fa-close"
                                style={{ cursor: "pointer", fontSize: 25, color: amber50, position: "absolute", top: 35, left: 950 }}
                            />
                        }
                        titleColor={"white"}
                    />
                    <CardText>
                        {this.state.loadingDependancies &&
                            <div style={{ textAlign: "center" }}>
                                <div>{strings.Loading_Note_Types}</div>
                                <CircularProgress size={20} />
                            </div>
                        }
                        {!this.state.loadingDependancies &&
                            <div>
                                <SelectField
                                    floatingLabelText={strings.Group}
                                    value={this.state.selectedGroup}
                                    onChange={(_e, _key, group) => {
                                        this.setState({ selectedGroup: group, enableScripts: false, frontEndFormScript: null, frontEndScript: null, selectedNoteType: null })
                                    }}
                                    style={{ width: 300 }}
                                >
                                    <MenuItem
                                        key={-1} value={"-1"}
                                        primaryText={strings.None}
                                    />
                                    {groups.map((group, index) =>
                                        <MenuItem
                                            key={index} value={group}
                                            primaryText={group}
                                        />
                                    )}
                                </SelectField>

                                {(this.state.selectedGroup && this.state.selectedGroup !== "-1") &&
                                    <SelectField
                                        floatingLabelText={strings.Type}
                                        value={this.state.selectedNoteType}
                                        onChange={(_e, _key, noteType) => {
                                            this.setState({
                                                selectedNoteType: noteType,
                                                frontEndFormScript: noteType.Scripts.FrontEndFormScript,
                                                frontEndScript: noteType.Scripts.FrontEndScript,
                                                frontEndPostValidationScript: noteType.Scripts.FrontEndPostValidationScript,
                                                enableScripts: noteType.EnableScripts,
                                            }, () => {
                                                if (this.state.enableScripts) {
                                                    this.renderFrontEndScriptToDom(noteType)
                                                }
                                            })
                                        }}
                                        style={{ width: 300, marginLeft: 50 }}
                                    >
                                        {noteTypes.map((noteType, index) =>
                                            <MenuItem
                                                key={index} value={noteType}
                                                primaryText={noteType.Name}
                                            />
                                        )}
                                    </SelectField>
                                }
                            </div>
                        }

                        {this.state.enableScripts &&
                            <div style={{ marginTop: 20, marginBottom: 20 }}>
                                <b>{this.state.selectedNoteType.Group} {this.state.selectedNoteType.Name} Form</b>
                                <div style={{ padding: 30, backgroundColor: "#efefef", borderRadius: 10 }}>
                                    <div dangerouslySetInnerHTML={{ __html: utils.replaceFrontEndFormScopeId(this.getScopeId(this.state.selectedNoteType), this.state.frontEndFormScript) }} />
                                    {this.state.errorTitle &&
                                        <div style={{ color: "red", fontSize: 15, marginTop: 20 }}>{this.state.errorTitle}</div>
                                    }
                                </div>
                            </div>
                        }
                        {!this.state.enableScripts &&
                            <div>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <TextField
                                        data-intercom-target={"Notes-Add-Entry-Title"}
                                        floatingLabelText={strings.Title}
                                        value={this.state.title || ""}
                                        onChange={(e, value) => { this.setState({ title: value }, () => this.checkValidate()) }}
                                        errorText={this.state.errorTitle}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                                <div>
                                    <TextField
                                        data-intercom-target={"Notes-Add-Entry-Note"}
                                        multiLine
                                        rows={4}
                                        rowsMax={4}
                                        floatingLabelText={strings.Note}
                                        value={this.state.note}
                                        onChange={event => this.setState({ note: event.target.value }, () => this.checkValidate())}
                                        errorText={this.state.errorNote}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                        style={{ width: "100%", textAlign: "left" }}
                                    />
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <TextField
                                        data-intercom-target={"Notes-Add-Entry-SubscriberList"}
                                        multiLine
                                        rows={1}
                                        floatingLabelText={strings.NoteSubscriberList}
                                        value={this.state.subscriberList}
                                        onChange={event => this.setState({ subscriberList: event.target.value }, () => this.checkValidate())}
                                        errorText={this.state.subscriberListError}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                        style={{ width: "100%", textAlign: "left" }}
                                    />
                                </div>
                            </div>
                        }
                    </CardText>

                    <CardActions style={{ textAlign: "right" }}>
                        <FlatButton data-intercom-target={"Notes-Add-Btn-Close-Add-New-Note-Drawer"} label={strings.Cancel} onTouchTap={() => this.props.closeDrawer()} />
                        <FlatButton
                            disabled={this.state.adding}
                            data-intercom-target={"Notes-Add-Btn-Save-New-Note"}
                            label={strings.Save}
                            primary
                            keyboardFocused
                            onClick={() => this.saveNoteData()}
                        />
                    </CardActions>
                </Card>
            </div>
        )
    }
}